var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailwindCssIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 135 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6197 0C49.6561 0 38.426 8.93066 33.9296 26.792C40.6706 17.865 48.5301 14.5164 57.5083 16.7464C62.6408 18.0185 66.2818 21.7143 70.3615 25.805C76.9416 32.4728 84.6184 40.1825 101.31 40.1825C119.274 40.1825 130.504 31.2518 135 13.3905C128.266 22.3248 120.407 25.6734 111.421 23.4361C106.289 22.164 102.648 18.4682 98.5682 14.3775C91.9661 7.67678 84.3222 0 67.6197 0ZM33.9296 40.1825C15.9659 40.1825 4.73591 49.1131 0.239502 66.9745C6.98776 58.0475 14.8473 54.6989 23.8182 56.9288C28.9507 58.201 32.5917 61.8968 36.6713 65.9984C43.2514 72.6553 50.9282 80.3759 67.6197 80.3759C85.5834 80.3759 96.8135 71.4453 101.31 53.584C94.5762 62.511 86.7167 65.8522 77.7312 63.6077C72.5987 62.3355 68.9577 58.6397 64.878 54.549C58.2979 47.8812 50.6212 40.1606 33.9296 40.1606V40.1825Z",
    fill: "#06B6D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white",
    transform: "translate(0.239502)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindCssIcon);
export default __webpack_public_path__ + "static/media/tailwind-css-icon.6a54db1f931b18811bd68fd565e3ce0f.svg";
export { ForwardRef as ReactComponent };